import CaptableOperation from './container';

export default CaptableOperation;
